import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import NAERLSLOGO from "../../../assets/images/NAERLS-Logo.png";

function SFRHeader() {
  return (
        <View
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <Image src={NAERLSLOGO} alt="NAERLS Logo" style={{ width: 120 }} />
          <View>
            <Text style={styles.title}>
              C4SEAS | NAERLS{"\n"}Soil Status, Management and Fertilizer{"\n"}Recommendation
              Interactive Map Report
            </Text>
          </View>
        </View>
  );
}

export default SFRHeader;

const styles = StyleSheet.create({
    title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },
});